/**
 * Date-only helpers in Asia/Tokyo for 行動記録 (YYYY-MM-DD strings).
 * Never derive "today" from toISOString() — that is UTC, a day behind before 9:00 JST.
 */
const WEEKDAY = ['日', '月', '火', '水', '木', '金', '土'];

export function tokyoToday() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo' }).format(new Date());
}

/** Current time of day in Asia/Tokyo as "HH:MM" (24h). Never the device's own zone. */
export function tokyoNowHHMM(now = new Date()) {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Tokyo', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
  }).formatToParts(now);
  const get = (t) => parts.find((p) => p.type === t)?.value || '00';
  return `${get('hour')}:${get('minute')}`;
}

/** Shift a YYYY-MM-DD by n days (UTC-midnight arithmetic on a date-only value: no zone shift). */
export function addDays(ymd, n) {
  const [y, m, d] = ymd.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + n)).toISOString().slice(0, 10);
}

/** 「9/20」, or 「今日」 when `today` is given and matches. */
export function dayLabel(ymd, today) {
  if (today && ymd === today) return '今日';
  const [, m, d] = ymd.split('-').map(Number);
  return `${m}/${d}`;
}

export function weekday(ymd) {
  const [y, m, d] = ymd.split('-').map(Number);
  return WEEKDAY[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
}
